<template>
    <div class="zoneListeProduits">

            <div v-if="isLoading" class="spinner"><i class="fa fa-circle-o-notch fa-spin fa-3x"></i><br/>Chargement...</div>
            <template v-for="(p, k, i) in products">
                <div class="blocProduit imgSelection" v-if="selection && (2 === i || 2 === k) && selection.imagePromo1.path">
                    <a :href="selection.linkPromo1" v-if="selection.linkPromo1">
                        <img class="lazyload img-fluid" :data-src="selection.imagePromo1.path">
                    </a>
                    <img v-else class="lazyload img-fluid" :data-src="selection.imagePromo1.path">
                </div>

                <div class="blocProduit imgSelection" v-if="selection && (5 === i || 5 === k) && selection.imagePromo2.path">
                    <a :href="selection.linkPromo2" v-if="selection.linkPromo2">
                        <img class="lazyload img-fluid" :data-src="selection.imagePromo2.path">
                    </a>
                    <img v-else class="lazyload img-fluid" :data-src="selection.imagePromo2.path">
                </div>

                <ponroy-product-card
                        :id="p.id"
                        :title="p.title"
                        :isNewFormula="false"
                        :isNew="isNew(p)"
                        :bestSales="bestSales(p)"
                        :provenSatisfaction="false"
                        :provenEffectiveness="false"
                        :isRecommended="false"
                        :url="p.url"
                        :cardImage="p.cardImage"
                        :shortDescription="p.shortDescription"
                        :subtitle="p.subtitle"
                        :references="p.references"
                        :lowestPrice="p.lowestPrice"
                        :lowestBasePrice="p.lowestBasePrice"
                        :reviews="p.reviews"
                        :reviewsAvg="p.reviewsAvg"
                        :available="!p.unavailable"
                        repository="site.repository.product_reference"
                ></ponroy-product-card>


            </template>

    </div>
</template>

<script>
    import Routing from 'routing';
    import PonroyProductCard from './ProductCard.vue';

    import {mapState, mapActions} from 'vuex';
    import store from '../store';

    export default {
        name: 'ponroy-product-group',
        store,
        components: {
            PonroyProductCard,
            Routing
        },
        props: {
            selection: {
                type: Object,
                required: false,
            }
        },
        computed: {
            ...mapState('facetedFilter', {
                products(state) {
                    return state.products;
                },
                isLoading(state) {
                    return state.isLoading;
                }
            })
        },
        methods: {
            bestSales(product) {
              return product.bestSales;
            },
            isNew(product) {
              return !product.bestSales && product.isNew;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/ProductGroup.vue